import React, {Component} from 'react';
import {withRouter} from "react-router-dom";
import {connect} from "react-redux";
import Logger from "../../../core/util/Logger";
import {popupDisplayHandlerAction} from "../../../actions/popup-display-action";
import {Formik, Field, Form, ErrorMessage} from 'formik';
import * as Yup from 'yup';
import {addMemberHostingDetailsAction} from "../../../actions/user/add-member-hosting-details-action";
import {resetReduxStoreAction} from "../../../actions/reset-redux-store-action";

let initialState = {message_type: '', message: '', hosting_details_submitted: false};

class HostingDetailsPopup extends Component {

    constructor() {
        super();
        this.state = initialState;
        this.formik = React.createRef();
    }


    componentDidUpdate() {
        if (this.props.member_hosting != null && this.state.hosting_details_submitted === true) {

            //get the success message
            if (this.props.member_hosting.success === true) {
                Logger.info("handling the success message");
                this.setState({
                    message_type: 'success',
                    message: this.props.member_hosting.data.message,
                    hosting_details_submitted: false
                });
            }
            //get the error message
            if (this.props.member_hosting.success === false) {
                Logger.info("handling the error message", this.props.member_hosting);
                this.setState({
                    message_type: 'error',
                    message: this.props.member_hosting.data.message,
                    hosting_details_submitted: false
                });
            }
        }
    }


    render() {
        return (
            <div tabIndex="-1" role="dialog"
                 style={this.props.popup.data.id === 'hosting_details_popup' &&
                 this.props.popup.data.shouldDisplay ? {display: 'block'} : {display: 'none'}}
                 className="modal fade show"
                 aria-modal="true">
                <div className="overlay">
                    <div role="document" className="modal-dialog help-dns-modal">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 id="exampleModalLabel" className="modal-title text-center">
                                    Get help from us to setup the DNS
                                </h5>

                                <button type="button" data-dismiss="modal" aria-label="Close"
                                        onClick={this.onClosePopupHandler.bind(this)}
                                        className="close">
                                    <span aria-hidden="true">×</span></button>
                            </div>

                            <div className="modal-body jrf-popup"
                                 style={this.state.hosting_details_submitted === true ? {display: 'block'} : {display: 'none'}}>
                                <p className="text-center">
                                    Please wait... hosting details are being submitted
                                </p>
                                <img src="../../../images/spinner.gif" className="loder"/>
                            </div>

                            <div
                                style={this.state.hosting_details_submitted === false ? {display: 'block'} : {display: 'none'}}>


                                <div
                                    style={(this.state.message !== '') ? {display: 'block'} : {display: 'none'}}
                                    className={this.state.message_type === 'success' ? 'help-dns-modal-text alert alert-success' : 'help-dns-modal-text alert alert-danger'}
                                    role="alert">
                                    {this.state.message}

                                    {/*We received the hosting details. Will be in touch with you if anything is needed.*/}
                                    {/*You can close out this page.*/}


                                    <div style={(this.state.message_type === 'success') ? {display: 'block'} : {display: 'none'}}>
                                        <button type="button" data-dismiss="modal"
                                                onClick={this.onClosePopupHandler.bind(this)}
                                                className="btn btn-secondary">Close
                                        </button>
                                    </div>
                                </div>

                                <div
                                    style={this.state.message_type !== '' && this.state.message_type === 'success' ? {display: 'none'} : {display: 'block'}}>
                                    <div className="modal-body">
                                        <p>
                                            Let us take care of the DNS setup.
                                            Share your domain hosting provider's username and password.
                                            All details are securely transmitted.
                                        </p>
                                    </div>

                                    <Formik
                                        ref={this.formik}
                                        initialValues={{
                                            hosting_provider: '',
                                            username: '',
                                            password: '',
                                        }}
                                        validationSchema={Yup.object().shape({
                                            hosting_provider: Yup.string()
                                                .required('hosting provider is required'),
                                            username: Yup.string()
                                                .required('hosting username is required'),
                                            password: Yup.string()
                                                .required('hosting password is required'),
                                        })}
                                        onSubmit={data => {
                                            this.onFormSubmitHandler(data);
                                        }}
                                        render={({errors, status, touched}) => (

                                            <Form>
                                                <div className="form-group align-items-center">
                                                    <div className={"row form-sec"}>
                                                        <div className="col-md-4">
                                                            <label htmlFor="hosting_provider">Hosting Provider</label>
                                                        </div>
                                                        <div className="col-md-8">
                                                            <Field name="hosting_provider" type="text"
                                                                   className={'form-control mb-2' + (errors.hosting_provider && touched.hosting_provider ? ' is-invalid' : '')}/>
                                                            <ErrorMessage name="hosting_provider" component="div"
                                                                          className="invalid-feedback"/>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="form-group align-items-center">
                                                    <div className={"row form-sec"}>
                                                        <div className="col-md-4">
                                                            <label htmlFor="username">Hosting Username</label>
                                                        </div>
                                                        <div className="col-md-8">
                                                            <Field name="username" type="text"
                                                                   className={'form-control mb-2' + (errors.username && touched.username ? ' is-invalid' : '')}/>
                                                            <ErrorMessage name="username" component="div"
                                                                          className="invalid-feedback"/>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="form-group align-items-center">
                                                    <div className={"row form-sec"}>
                                                        <div className="col-md-4">
                                                            <label htmlFor="password">Hosting Password</label>
                                                        </div>
                                                        <div className="col-md-8">
                                                            <Field name="password" type="text"
                                                                   className={'form-control mb-2' + (errors.password && touched.password ? ' is-invalid' : '')}/>
                                                            <ErrorMessage name="password" component="div"
                                                                          className="invalid-feedback"/>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className={'ssl-e-wrap'}>
                                                    <img src={process.env.PUBLIC_URL + '/images/ssl_stock_lock.png'} alt=""/>
                                                    <p>Details are securely transmitted. This page is encrypted with SSL for maximum security.</p>
                                                </div>

                                                <div className="modal-footer">
                                                    <button type="button" data-dismiss="modal"
                                                            onClick={this.onClosePopupHandler.bind(this)}
                                                            className="btn btn-secondary">Cancel
                                                    </button>
                                                    <button type="submit" className="btn btn-primary">
                                                        Submit
                                                    </button>
                                                </div>
                                            </Form>
                                        )}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }


    async onFormSubmitHandler(data) {
        Logger.info(" form submitted ", data);
        await this.props.resetReduxStore('RESET_MEMBER_HOSTING_DETAILS');
        this.setState({hosting_details_submitted: true, message: '', message_type: ''});
        await new Promise(resolve => setTimeout(resolve, 2000));
        let token = this.props.user.data.auth.token;
        this.props.addMemberHostingDetails(data, token);
    }

    onClosePopupHandler() {
        Logger.info("mandrill verification popup is closed");
        this.formik.current.resetForm();
        this.setState(initialState);
        let payload = {
            id: "hosting_details_popup",
            shouldDisplay: false
        };
        this.props.handlePopupVisibility(payload);
    }
}

const mapStateToProps = (state) => {
    return {
        user: state.user,
        popup: state.popup,
        mandrill_verification: state.mandrill_verification,
        member_hosting: state.member_hosting
    };
};

const actions = {
    handlePopupVisibility: popupDisplayHandlerAction,
    addMemberHostingDetails: addMemberHostingDetailsAction,
    resetReduxStore: resetReduxStoreAction
};


export default withRouter(connect(mapStateToProps, actions)(HostingDetailsPopup));
